<template>
  <v-tooltip right color="secondary" :key="`mini_${index}`" :disabled="isSubGroup">
    <template v-slot:activator="{ on: tooltip }">
      <v-menu
        :disabled="!listItem.show || !listItem.isGroup || !getOptionIsVisible()"
        min-width="170"
        content-class="mini-drawer-menu"
        right
        offset-x
      >
        <template v-slot:activator="{ on: menu, attrs }">
          <NavListItem
            v-if="listItem.show && getOptionIsVisible()"
            :class="itemClass"
            :activeClass="itemActiveClass"
            :name="listItem.text"
            :linkName="listItem.linkName"
            :icon="listItem.icon"
            :activator="{ ...menu, ...tooltip }"
            :attrs="attrs"
            @navClick="$emit('item-clicked', false)"
          />
        </template>
        <v-list link nav dense class="mini-drawer-list">
          <v-list-item-group color="primary">
            <template v-for="(subItem, subIndex) in listItem.items">
              <MiniNavListItemGroup
                :listItem="subItem"
                :index="subIndex"
                isSubGroup
                @item-clicked="$emit('item-clicked', false)"
              />
            </template>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </template>
    <span>{{ listItem.text }}</span>
  </v-tooltip>
</template>

<script>
import NavListItem from './NavListItem.vue'
export default {
  name: 'MiniNavListItemGroup',
  components: {
    NavListItem,
  },
  props: {
    listItem: {
      type: Object,
      default: () => {},
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    activator: {
      type: Object,
      default: () => {},
    },
    isSubGroup: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    itemClass() {
      if (this.isSubGroup) {
        return 'drawer-dropdown-item'
      } else {
        return {
          'mini-drawer-button': !this.listItem.isGroup,
          'mini-drawer-menu-button': this.listItem.isGroup,
          'mini-drawer-menu-button-link-active': this.listItem.isGroup && this.isActive(),
        }
      }
    },
    itemActiveClass() {
      if (this.isSubGroup) {
        return 'drawer-dropdown-item-active'
      } else {
        return this.listItem.isGroup ? 'mini-drawer-menu-button-active' : 'mini-drawer-button-active'
      }
    },
  },
  methods: {
    getOptionIsVisible() {
      // test the case if a item is a group but all of it sub items are invisible i.e. show = false
      // true = visible
      // false = invisible
      const item = this.listItem
      if (this.listItem.isGroup) {
        if (item.items) {
          const foundVisibleSubItem = item.items.find(obj => obj.show)
          return this.listItem.show && (foundVisibleSubItem ? true : false)
        }
        return false
      }

      return this.listItem.show
    },
    isActive() {
      const item = this.listItem
      if (item.isGroup && item.items) {
        const possibleLinkNames = this._getAllLinkNames(item.items)
        return possibleLinkNames.includes(this.$route.name)
      }

      return false
    },
    _getAllLinkNames(items) {
      let names = []
      for (let i = 0; i < items.length; i++) {
        if (items[i].isGroup) {
          names = names.concat(this._getAllLinkNames(items[i].items))
        } else {
          names.push(items[i].linkName)
        }
      }
      return names
    },
  },
}
</script>
